<script setup lang="ts">
import ConfigSection from "@/layouts/content/ConfigSection.vue";
import { NavBarStyle, useNavBarStore } from "@/stores/navbar";
import { storeToRefs } from "pinia";

const { t } = useI18n();

const { style, isSideBar } = storeToRefs(useNavBarStore());
function changeStyle(newStyle: NavBarStyle) {
	style.value = newStyle;
}
</script>

<template>
	<ConfigSection
		:title="t('profile.preferences')"
		:description="`Gérer vos préférences pour l’application web.`"
	>
		<div>
			<h5>Position de la bar de navigation</h5>
			<div class="flex gap-2">
				<div>
					<button
						class="border-border hover:bg-focus w-34 bg-base-100 relative h-20 overflow-clip rounded-xl border"
						:class="isSideBar ? 'border-primary border' : 'hover:border-secondary'"
						@click="changeStyle(NavBarStyle.SIDE_BAR)"
					>
						<div class="flex size-full flex-col">
							<div class="bg-base-200 h-6 w-full" />
							<div class="bg-base-300 h-full w-6" />
						</div>
					</button>
					<div class="pl-1">Gauche</div>
				</div>
				<div>
					<button
						class="border-border hover:bg-focus w-34 bg-base-100 relative h-20 overflow-clip rounded-xl border"
						:class="!isSideBar ? 'border-primary border' : 'hover:border-secondary'"
						@click="changeStyle(NavBarStyle.TOP_BAR)"
					>
						<div class="flex size-full flex-col">
							<div class="bg-base-200 h-4 w-full" />
							<div class="bg-base-300 h-4 w-full" />
						</div>
					</button>
					<div class="pl-1">Haut</div>
				</div>
			</div>
		</div>
	</ConfigSection>
</template>
